import { SEARCH_PARAM_DELETE_STORE_SUCCESS, storesRoute } from '#shared/lib/routes';
import { getMasterDomain } from '#shared/lib/url';

export const buildStoresRedirectUrl = (storeName: string): string => {
    const baseUrl = 'https://' + getMasterDomain(window.location.host) + storesRoute.route;

    const redirectUrl = new URL(baseUrl);

    redirectUrl.searchParams.set(SEARCH_PARAM_DELETE_STORE_SUCCESS, storeName);

    return redirectUrl.toString();
};
